import { Input } from 'antd';

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

/**
 * Ghi chú ĐƠN HÀNG ở cuối cụm tiền cột phải màn POS — bind vào field
 * `description` của form POS chung (`POSPage`), field này BE map sang
 * `notes.user_note` khi tạo đơn (`pos-order.service.ts`). Tách component
 * trình bày riêng để test không cần dựng cả `POSPage`.
 *
 * Tên "khách hàng" cũ dễ nhầm với ghi chú lưu trên hồ sơ khách (trong
 * CustomerDialog) — ghi chú ở đây chỉ theo một đơn, xoá khách không xoá nó.
 *
 * `disabled` — dùng ở màn sửa đơn khi đơn đã chuyển trạng thái chỉ-sửa-giao-
 * hàng (`isShippingOnlyEdit`, xem `Orders/edit.tsx`): chỉ khoá RIÊNG ô này
 * (sidebar `CustomerNoteField`), không phải khoá field `description` toàn
 * cục. Field `description` còn một chỗ nhập khác dùng CHUNG form instance —
 * `FloatingField name="description"` ("Ghi chú") trong `CustomerDialog`
 * (`CustomerInfoFields.tsx`) — dialog đó không đọc prop `disabled` này nên
 * người dùng vẫn gõ được vào đó kể cả khi sidebar đang khoá. Vô hại: khi
 * `isShippingOnlyEdit`, `edit.tsx` bỏ hẳn key `notes` khỏi payload update
 * (xem chỗ build `orderService.update`), bất kể giá trị đến từ ô nào, nên
 * kết quả lưu vẫn đúng dù prop này không khoá được cả hai chỗ.
 */
export function CustomerNoteField({ value, onChange, disabled }: Props): JSX.Element {
  return (
    <Input.TextArea
      aria-label="Ghi chú đơn hàng"
      placeholder="Thêm ghi chú đơn hàng..."
      value={value}
      onChange={(e) => onChange(e.target.value)}
      rows={2}
      size="small"
      disabled={disabled}
    />
  );
}
